import PropTypes from "prop-types";

export default function DetailPageSidebar({ sections }) {
    return (
        <aside className="detail-sidebar">
            {sections.map((section, i) => (
                <div key={i} className="detail-sidebar__section">
                    {section.title && (
                        <h3 className="detail-sidebar__section-title">
                            {section.title}
                        </h3>
                    )}
                    <div className="detail-sidebar__section-content">
                        {section.content}
                    </div>
                </div>
            ))}
        </aside>
    );
}

DetailPageSidebar.propTypes = {
    sections: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string,
            content: PropTypes.node.isRequired,
        })
    ).isRequired,
};
